import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBox2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBox2"><Path d="M21 12V21H3V13.5H7.49171C8.11967 15.3883 9.90081 16.75 12 16.75C14.0992 16.75 15.8803 15.3883 16.5083 13.5L21 13.5L21 12Z" fill="currentColor"/><Path d="M3 12H8.75001V12.0067C8.7536 13.7985 10.2073 15.25 12 15.25C13.7949 15.25 15.25 13.7949 15.25 12L21 12V3L3.00006 3.00001L3 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBox2;
